import React from 'react';
import { Route, Switch, Redirect, RouteComponentProps } from 'react-router-dom';
// core components
import { Helmet } from 'react-helmet';

// routes.js exports no AdminAptRoutes/AptRoutes (the old named imports were
// always undefined and unreferenced), so only the default import remains
import routes from 'routes';
import withHeader from 'components/HOC/withHeader';
import ErrorPage from 'views/404';
import { Container } from 'reactstrap';
import Cookies from 'js-cookie';
import getNewAptRoute, { NewAppointmentContext } from 'views/new-appointment';
import { connect } from 'react-redux';
import shopActions from 'store/shop/actions';
import { NEW_APT_STEPS } from 'constant';
import { getBookingRoute } from 'views/new-appointment/booking';
import CallerBannerHost from 'views/calendar/caller-id/CallerBannerHost';

// Subset of the route-entry shape read here; matches withHeader.tsx's own local RouteEntry.
interface RouteEntry {
	path: string;
	// A couple of routes.js entries omit `name` entirely (e.g. ticket-by-staff routes).
	name?: string;
	component: React.ComponentType<any>;
	layout: string;
	stats?: boolean;
	isDisplayHeader?: boolean;
	isDisplayNav?: boolean;
	isManager?: boolean;
	isHistoryBack?: boolean;
}

// Mirrors withHeader's own (unexported) WithHeaderOptions; `isManager` isn't part of it
// (withHeader ignores unknown keys) but is passed through here in the original code.
interface WithHeaderOptions {
	title?: string;
	stats?: boolean;
	isDisplayHeader?: boolean;
	isDisplayNav?: boolean;
	isManager?: boolean;
	isHistoryBack?: boolean;
}

// index.tsx renders <AdminLayout {...routeProps} />, so route props are part of the contract
interface AdminProps extends RouteComponentProps {
	initShopData: () => void;
}

class Admin extends React.Component<AdminProps> {
	componentDidMount() {
		this.props.initShopData();
	}
	componentDidUpdate() {
		document.documentElement.scrollTop = 0;
		document.scrollingElement!.scrollTop = 0;
	}
	getRoutes = (routes: RouteEntry[]) => {
		return routes.map((prop, key) => {
			if (prop.layout !== 'admin') return null;
			// Cookies.get returns string | undefined; prop.isManager is boolean. Loose `==` (never
			// strictly true) is pre-existing behavior here, so the comparison is cast to keep it as-is.
			if ((Cookies.get('isManager') as any) == prop.isManager) {
				return this.renderComponent(
					prop.path,
					withHeader(prop.component, {
						title: prop.name,
						stats: prop.stats || false,
						isDisplayHeader: prop.hasOwnProperty('isDisplayHeader')
							? prop.isDisplayHeader
							: true,
						isDisplayNav: prop.hasOwnProperty('isDisplayNav')
							? prop.isDisplayNav
							: true,
						isManager: prop.hasOwnProperty('isManager')
							? prop.isManager
							: true,
						isHistoryBack: prop.hasOwnProperty('isManager')
							? prop.isHistoryBack
							: true,
					} as WithHeaderOptions),
					key
				);
			}

		});
	};

	renderComponent = (path: string, component: React.ComponentType<any>, key: number) => (
		<Route exact key={key} path={path} component={component} />
	);
	render() {
		return (
			<Container className="px-0 mx-0" fluid>
				<Helmet titleTemplate={process.env.REACT_APP_NAME + ' | %s'} />
				<Switch>
					{/* Send each role to its own home page. Must go through the router: under the
					  native HashRouter window.location.pathname is always "/", and a full-page
					  redirect drops the hash, landing managers on "#/" where no route matches (blank page). */}
					{Cookies.get('isManager') === '1'
						? <Redirect exact from="/" to="/overview" />
						: <Redirect exact from="/overview" to="/" />}
					{this.getRoutes(routes)}
					{this.getRoutes([getBookingRoute()])}
					<NewAppointmentContext>
						<Switch>
							{this.getRoutes([
								getNewAptRoute(),
								getNewAptRoute(NEW_APT_STEPS.SERVICE),
								getNewAptRoute(NEW_APT_STEPS.DATE_STAFF),
								getNewAptRoute(NEW_APT_STEPS.TIME_SLOT),
								getNewAptRoute(NEW_APT_STEPS.REVIEW),
								getNewAptRoute(NEW_APT_STEPS.SUCCESS),
							])}
						</Switch>
					</NewAppointmentContext>
					{/* <Route path="/404" name="Page not found" component={ErrorPage} />
					<Redirect to="/404" /> */}
				</Switch>
				{/* owner-only app-wide incoming-call banners (Caller ID) */}
				<CallerBannerHost />
			</Container>
		);
	}
}

export default connect(null, (dispatch) => ({
	initShopData: () => dispatch(shopActions.init()),
}))(Admin);